(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-with-text-play-toggle')) {
    const hoverControlVideos = new WeakSet();

    const syncHoverControls = (video, hovering) => {
      const showControls = !video.paused && hovering;
      video.toggleAttribute('controls', showControls);
    };

    const bindHoverControls = (video) => {
      if (!(video instanceof HTMLVideoElement) || hoverControlVideos.has(video)) return;
      if (!video.hasAttribute('data-hover-controls')) return;

      const media = video.closest('.image-with-text__media');
      if (!media) return;

      hoverControlVideos.add(video);
      let hovering = false;

      const update = () => syncHoverControls(video, hovering);

      media.addEventListener('pointerenter', () => {
        hovering = true;
        update();
      });
      media.addEventListener('pointerleave', () => {
        hovering = false;
        update();
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('ended', update);
      update();
    };

    const bindHoverControlsIn = (root = document) => {
      root.querySelectorAll?.('.image-with-text__video[data-hover-controls]').forEach(bindHoverControls);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindHoverControlsIn(), { once: true });
    } else {
      bindHoverControlsIn();
    }
    document.addEventListener('shopify:section:load', (event) => {
      bindHoverControlsIn(event.target);
    });

    customElements.define(
      'image-with-text-play-toggle',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.video = this.closest('.image-with-text__media')?.querySelector('video');
          this.playIcon = this.querySelector('.image-with-text__play-icon');
          this.pauseIcon = this.querySelector('.image-with-text__pause-icon');

          if (!this.button || !(this.video instanceof HTMLVideoElement)) return;

          bindHoverControls(this.video);

          this.onClick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.togglePlayback();
          };
          this.onPlay = () => this.sync(true);
          this.onPause = () => this.sync(false);

          this.button.addEventListener('click', this.onClick);
          this.video.addEventListener('play', this.onPlay);
          this.video.addEventListener('pause', this.onPause);
          this.video.addEventListener('ended', this.onPause);
          this.sync(!this.video.paused);
        }

        disconnectedCallback() {
          this.button?.removeEventListener('click', this.onClick);
          this.video?.removeEventListener('play', this.onPlay);
          this.video?.removeEventListener('pause', this.onPause);
          this.video?.removeEventListener('ended', this.onPause);
        }

        ensureSources() {
          const sources = this.video.querySelectorAll('source[data-video-source]');
          let changed = false;

          sources.forEach((source) => {
            const isActive = !source.media || window.matchMedia(source.media).matches;
            const nextSource = isActive ? source.dataset.videoSource : '';
            const currentSource = source.getAttribute('src') || '';

            if (nextSource && nextSource !== currentSource) {
              source.setAttribute('src', nextSource);
              changed = true;
            }
          });

          if (changed) this.video.load();
        }

        togglePlayback() {
          this.ensureSources();

          if (this.video.paused) {
            this.video.play()?.catch(() => {});
            return;
          }

          this.video.pause();
        }

        sync(isPlaying) {
          const playLabel = this.button.dataset.playLabel;
          const pauseLabel = this.button.dataset.pauseLabel;

          this.button.setAttribute('aria-label', isPlaying ? pauseLabel : playLabel);
          this.playIcon?.classList.toggle('hidden', isPlaying);
          this.pauseIcon?.classList.toggle('hidden', !isPlaying);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-feature-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mini-feature-collection')) {
    const DRAG_THRESHOLD = 4;
    const INERTIA_FRICTION = 0.95;
    const INERTIA_MIN_VELOCITY = 0.02;

    class MiniFeatureCollection extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-ref="scroller"]');
        this.previousButton = this.querySelector('[data-ref="previous"]');
        this.nextButton = this.querySelector('[data-ref="next"]');
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        if (!this.scroller) return;

        this.scroller.addEventListener('scroll', this.updateControls, { passive: true, signal });
        this.scroller.addEventListener('pointerdown', this.onPointerDown, { signal });
        window.addEventListener('resize', this.updateControls, { passive: true, signal });
        this.previousButton?.addEventListener('click', this.previous, { signal });
        this.nextButton?.addEventListener('click', this.next, { signal });

        this.updateControls();
        requestAnimationFrame(() => this.updateControls());
      }

      disconnectedCallback() {
        this.stopInertia();
        this.abortController?.abort();
      }

      prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      getScrollAmount() {
        const item = this.scroller?.querySelector('.mini-feature__item');
        const styles = getComputedStyle(this.querySelector('.mini-feature__track') || this.scroller);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        if (item instanceof HTMLElement && item.offsetWidth > 0) {
          return item.offsetWidth + gap;
        }
        return Math.max(120, this.scroller.clientWidth * 0.28);
      }

      previous = () => {
        this.scrollByDirection(-1);
      };

      next = () => {
        this.scrollByDirection(1);
      };

      scrollByDirection(direction) {
        if (!this.scroller) return;
        this.stopInertia();
        const step = this.getScrollAmount();
        const rtl = getComputedStyle(this.scroller).direction === 'rtl';
        const current = Math.abs(this.scroller.scrollLeft);
        const maxScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        const currentIndex = Math.round(current / step);
        const target = Math.max(0, Math.min(maxScroll, (currentIndex + direction) * step));
        this.scroller.scrollTo({
          left: rtl ? -target : target,
          behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        });
      }

      stopInertia() {
        if (this.inertiaFrame) {
          cancelAnimationFrame(this.inertiaFrame);
          this.inertiaFrame = 0;
        }
      }

      startInertia(velocity) {
        if (!this.scroller || this.prefersReducedMotion()) {
          this.updateControls();
          return;
        }

        let v = velocity;
        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
        let last = performance.now();

        const step = (now) => {
          const dt = Math.min(now - last, 32);
          last = now;
          v *= Math.pow(INERTIA_FRICTION, dt / 16);
          if (Math.abs(v) < INERTIA_MIN_VELOCITY) {
            this.inertiaFrame = 0;
            this.updateControls();
            return;
          }

          const rtl = getComputedStyle(this.scroller).direction === 'rtl';
          const min = rtl ? -maxScroll : 0;
          const max = rtl ? 0 : maxScroll;
          const next = Math.max(min, Math.min(max, this.scroller.scrollLeft + v * dt));
          this.scroller.scrollLeft = next;

          if (next <= min || next >= max) {
            this.inertiaFrame = 0;
            this.updateControls();
            return;
          }

          this.inertiaFrame = requestAnimationFrame(step);
        };

        this.inertiaFrame = requestAnimationFrame(step);
      }

      onPointerDown = (event) => {
        if (this.dragging) return;
        if (event.pointerType === 'touch') return;
        if (event.button !== 0) return;
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('a, button')) return;
        if (!this.scroller) return;

        this.stopInertia();

        const startX = event.clientX;
        const startScrollLeft = this.scroller.scrollLeft;
        let previousX = startX;
        let previousTime = performance.now();
        let velocity = 0;
        let moved = false;
        const controller = new AbortController();
        const { signal } = controller;

        const onPointerMove = (moveEvent) => {
          const deltaX = moveEvent.clientX - startX;
          if (!moved) {
            if (Math.abs(deltaX) < DRAG_THRESHOLD) return;
            moved = true;
            this.dragging = true;
            this.setAttribute('dragging', '');
            this.scroller.setPointerCapture(moveEvent.pointerId);
            document.addEventListener('click', preventClick, { capture: true, once: true, signal });
          }

          const now = performance.now();
          const frameDelta = moveEvent.clientX - previousX;
          const dt = Math.max(now - previousTime, 1);
          velocity = velocity * 0.6 + (-frameDelta / dt) * 0.4;
          previousX = moveEvent.clientX;
          previousTime = now;
          moveEvent.preventDefault();
          this.scroller.scrollLeft = startScrollLeft - deltaX;
        };

        const onPointerUp = (upEvent) => {
          controller.abort();
          this.dragging = false;
          this.removeAttribute('dragging');
          if (moved && this.scroller.hasPointerCapture(upEvent.pointerId)) {
            this.scroller.releasePointerCapture(upEvent.pointerId);
          }
          if (moved && Math.abs(velocity) > INERTIA_MIN_VELOCITY) {
            this.startInertia(velocity);
          } else {
            this.updateControls();
          }
        };

        const preventClick = (clickEvent) => {
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
        };

        document.addEventListener('pointermove', onPointerMove, { signal });
        document.addEventListener('pointerup', onPointerUp, { signal });
        document.addEventListener('pointercancel', onPointerUp, { signal });
      };

      updateControls = () => {
        if (!this.scroller) return;
        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
        const offset = Math.abs(this.scroller.scrollLeft);
        const atStart = offset <= 2;
        const atEnd = offset >= maxScroll - 2;
        const canScroll = maxScroll > 2;

        this.toggleAttribute('data-can-scroll', canScroll);
        this.toggleAttribute('data-at-start', !canScroll || atStart);
        this.toggleAttribute('data-at-end', !canScroll || atEnd);

        if (this.previousButton) {
          this.previousButton.disabled = !canScroll || atStart;
          this.previousButton.setAttribute('aria-disabled', String(!canScroll || atStart));
        }
        if (this.nextButton) {
          this.nextButton.disabled = !canScroll || atEnd;
          this.nextButton.setAttribute('aria-disabled', String(!canScroll || atEnd));
        }
      };
    }

    customElements.define('mini-feature-collection', MiniFeatureCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sale-countdown')) {
    class SaleCountdown extends HTMLElement {
      #timer;
      #minuteMark = -1;

      connectedCallback() {
        const end = Number(this.dataset.end);
        if (!Number.isFinite(end) || end <= 0) return;
        this.#tick(end);
        this.#timer = window.setInterval(() => this.#tick(end), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.#timer);
      }

      #tick(end) {
        const remaining = Math.max(0, end - Math.floor(Date.now() / 1000));
        const days = Math.floor(remaining / 86400);
        const hours = Math.floor((remaining % 86400) / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;

        this.#set('days', days);
        this.#set('hours', hours);
        this.#set('minutes', minutes);
        this.#set('seconds', seconds);

        const minuteMark = Math.floor(remaining / 60);
        if (minuteMark !== this.#minuteMark) {
          this.#minuteMark = minuteMark;
          const template = this.dataset.labelTemplate || '';
          const label = template
            .replace('__DAYS__', String(days))
            .replace('__HOURS__', String(hours))
            .replace('__MINUTES__', String(minutes))
            .replace('__SECONDS__', String(seconds));
          if (label) this.setAttribute('aria-label', label);
        }

        if (remaining === 0) {
          window.clearInterval(this.#timer);
          const ended = this.dataset.endedLabel;
          if (ended) this.setAttribute('aria-label', ended);
          this.classList.add('is-ended');
        }
      }

      #set(unit, value) {
        const node = this.querySelector(`[data-unit="${unit}"]`);
        if (!node) return;
        const text = String(value).padStart(2, '0');
        if (node.textContent !== text) node.textContent = text;
      }
    }

    customElements.define('sale-countdown', SaleCountdown);
  }

  if (!customElements.get('simple-announce-live')) {
    const editorSelection = {
      sectionId: '',
      blockId: '',
    };

    class SimpleAnnounceLive extends HTMLElement {
      #index = 0;
      #timer;
      #animating = false;
      #ready = false;
      #items = [];
      #observer;
      #stickyObserver;
      #editorPaused = false;

      connectedCallback() {
        this.classList.remove('is-expanding', 'is-fading', 'is-open', 'is-inspecting');
        this.#ready = false;
        this.#bindEditor();
        this.#syncItems();
        this.#observeItems();
        this.#observeSticky();

        document.addEventListener('visibilitychange', this.#onVisibility);
        document.addEventListener('shopify:section:load', this.#onSectionLoad);
        document.addEventListener('shopify:block:select', this.#onBlockSelect);
        this.addEventListener('mouseenter', this.#onPointerPause);
        this.addEventListener('mouseleave', this.#onPointerResume);
        this.addEventListener('focusin', this.#onPointerPause);
        this.addEventListener('focusout', this.#onFocusOut);
        this.addEventListener('click', this.#onNavClick);

        if (this.#editorPaused) {
          this.#holdOneSlide();
          return;
        }

        this.#reveal();
      }

      disconnectedCallback() {
        this.#stopCycle();
        this.#observer?.disconnect();
        this.#stickyObserver?.disconnect();
        document.body.style.removeProperty('--simple-announce-height');
        document.removeEventListener('visibilitychange', this.#onVisibility);
        document.removeEventListener('shopify:section:load', this.#onSectionLoad);
        document.removeEventListener('shopify:block:select', this.#onBlockSelect);
        this.removeEventListener('mouseenter', this.#onPointerPause);
        this.removeEventListener('mouseleave', this.#onPointerResume);
        this.removeEventListener('focusin', this.#onPointerPause);
        this.removeEventListener('focusout', this.#onFocusOut);
        this.removeEventListener('click', this.#onNavClick);
      }

      #parseDuration(value, fallback) {
        const parsed = parseFloat(value);
        return Number.isFinite(parsed) ? parsed : fallback;
      }

      #sectionId() {
        return this.closest('.shopify-section')?.id || '';
      }

      #blockId(item) {
        const raw = item?.getAttribute('data-shopify-editor-block');
        if (!raw) return '';

        try {
          return JSON.parse(raw).id || '';
        } catch {
          return '';
        }
      }

      #blockItem(target) {
        if (!(target instanceof Element)) return null;
        return target.closest('.simple-announce__item') || target.querySelector('.simple-announce__item');
      }

      get #editorMode() {
        return Boolean(window.Shopify?.designMode);
      }

      #observeItems() {
        this.#observer?.disconnect();
        const inner = this.querySelector('.simple-announce__inner');
        if (!inner) return;

        this.#observer = new MutationObserver(() => this.#syncItems());
        this.#observer.observe(inner, { childList: true, subtree: true });
      }

      #observeSticky() {
        this.#stickyObserver?.disconnect();
        if (!this.hasAttribute('data-sticky')) {
          document.body.style.removeProperty('--simple-announce-height');
          return;
        }

        const section = this.closest('.shopify-section');
        if (!section) return;

        const publishHeight = () => {
          const height = Math.round(section.getBoundingClientRect().height);
          document.body.style.setProperty('--simple-announce-height', `${height}px`);
        };

        publishHeight();
        this.#stickyObserver = new ResizeObserver(publishHeight);
        this.#stickyObserver.observe(section);
      }

      #dedupeActive() {
        if (this.#items.length === 0) return;

        const keepId = this.#editorPaused ? editorSelection.blockId : '';
        let keep = keepId ? this.#items.find((item) => this.#blockId(item) === keepId) : null;
        if (!keep) keep = this.#items.find((item) => item.classList.contains('is-active')) || this.#items[0];

        this.#activate(Math.max(0, this.#items.indexOf(keep)));
      }

      #activate(index) {
        if (index < 0 || index >= this.#items.length) return;

        this.#items.forEach((item, itemIndex) => {
          const isActive = itemIndex === index;
          item.classList.toggle('is-active', isActive);
          item.classList.toggle('is-current', isActive && this.#editorPaused);
          item.classList.remove('is-leaving', 'is-reset', 'is-pending');
          item.inert = !isActive;
          if (isActive) {
            item.removeAttribute('hidden');
            item.removeAttribute('aria-hidden');
          } else {
            if (this.#editorPaused) item.setAttribute('hidden', '');
            else item.removeAttribute('hidden');
            item.setAttribute('aria-hidden', 'true');
          }
        });

        this.#index = index;
        this.#animating = false;
        this.classList.toggle('is-inspecting', this.#editorPaused);
      }

      #bindEditor() {
        this.#editorPaused = Boolean(
          this.#editorMode && editorSelection.blockId && editorSelection.sectionId === this.#sectionId()
        );
      }

      #holdOneSlide(item) {
        this.#editorPaused = true;
        this.#ready = true;
        this.#animating = false;
        this.classList.add('is-open', 'is-inspecting');
        this.classList.remove('is-expanding', 'is-fading', 'has-carousel', 'is-reverse');
        this.#stopCycle();
        this.#items = [...this.querySelectorAll('.simple-announce__item')];
        let target = item;
        if (!target && editorSelection.blockId) {
          target = this.#items.find((entry) => this.#blockId(entry) === editorSelection.blockId);
        }
        if (!target) target = this.#items.find((entry) => entry.classList.contains('is-active')) || this.#items[0];
        this.#activate(Math.max(0, this.#items.indexOf(target)));
      }

      #pauseForEditor(item) {
        this.#editorPaused = true;
        this.#ready = true;
        editorSelection.sectionId = this.#sectionId();
        editorSelection.blockId = this.#blockId(item);
        this.#holdOneSlide(item);
      }

      #resumeCarousel() {
        this.#editorPaused = false;
        editorSelection.sectionId = '';
        editorSelection.blockId = '';
        this.classList.remove('is-inspecting');
        this.#items.forEach((item) => item.classList.remove('is-current'));
        this.#ready = true;
        this.classList.add('is-open');
        this.classList.remove('is-expanding', 'is-fading');
        this.#syncItems();
        this.#startCycle();
      }

      #keepEditorPause() {
        this.#holdOneSlide();
      }

      #syncItems() {
        this.#items = [...this.querySelectorAll('.simple-announce__item')];
        const canSlide = this.#items.length > 1 && !this.#editorPaused && (this.hasAttribute('autoplay') || this.getAttribute('data-nav') === 'true');
        this.classList.toggle('has-carousel', canSlide);
        this.classList.toggle('has-nav', this.getAttribute('data-nav') === 'true' && this.#items.length > 1 && !this.#editorPaused);

        const nav = this.querySelector('.simple-announce__nav');
        if (nav) {
          const showNav = this.classList.contains('has-nav');
          nav.toggleAttribute('hidden', !showNav);
          nav.setAttribute('aria-hidden', showNav ? 'false' : 'true');
        }

        if (this.#items.length === 0) {
          this.#index = 0;
          this.#stopCycle();
          return;
        }

        if (canSlide) this.setAttribute('aria-live', 'polite');
        else this.removeAttribute('aria-live');

        if (!this.hasAttribute('autoplay') || this.#items.length < 2) this.#stopCycle();

        if (this.#animating) return;

        this.#dedupeActive();
      }

      #onVisibility = () => {
        if (document.hidden) this.#stopCycle();
        else this.#startCycle();
      };

      #onPointerPause = () => {
        if (this.#editorMode) return;
        this.#stopCycle();
      };

      #onPointerResume = () => {
        if (this.#editorMode) return;
        this.#startCycle();
      };

      #onFocusOut = (event) => {
        if (this.#editorPaused || this.#editorMode) return;
        if (this.contains(event.relatedTarget)) return;
        this.#startCycle();
      };

      #onSectionLoad = (event) => {
        if (!event.target?.contains?.(this)) return;
        this.#observeItems();
        this.#observeSticky();
        this.#syncItems();
      };

      #onBlockSelect = (event) => {
        if (event.detail?.load) return;
        const item = this.#blockItem(event.target);
        if (!item || !this.contains(item)) return;
        editorSelection.sectionId = this.#sectionId();
        editorSelection.blockId = this.#blockId(item);
        this.#items = [...this.querySelectorAll('.simple-announce__item')];
        this.#pauseForEditor(item);
      };

      #stopCycle = () => {
        window.clearInterval(this.#timer);
        this.#timer = undefined;
      };

      #startCycle = () => {
        this.#stopCycle();
        if (this.#editorPaused || !this.#ready || this.#items.length < 2) return;
        if (!this.hasAttribute('autoplay')) return;
        if (document.hidden) return;
        if (!this.#editorMode && (this.matches(':hover') || this.matches(':focus-within'))) return;

        const holdMs = this.#parseDuration(this.getAttribute('autoplay'), 5) * 1000;
        this.#timer = window.setInterval(() => this.#advance(), holdMs);
      };

      #advance() {
        if (this.#editorPaused || this.#items.length < 2) return;
        this.#goTo((this.#index + 1) % this.#items.length, true, false);
      }

      #onNavClick = (event) => {
        const button = event.target.closest('[data-announce-dir]');
        if (!button || this.#editorPaused || this.#items.length < 2) return;

        const direction = Number(button.getAttribute('data-announce-dir'));
        if (!Number.isFinite(direction) || direction === 0) return;

        const nextIndex = (this.#index + direction + this.#items.length) % this.#items.length;
        this.#goTo(nextIndex, true, direction < 0);
        if (this.hasAttribute('autoplay')) this.#startCycle();
      };

      #goTo(nextIndex, animate = true, reverse = false) {
        if (nextIndex === this.#index || nextIndex < 0 || nextIndex >= this.#items.length) return;
        if (this.#animating) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.classList.toggle('is-reverse', reverse);
        if (!animate || this.#editorPaused || reduceMotion) {
          this.#activate(nextIndex);
          this.classList.remove('is-reverse');
          return;
        }

        const current = this.#items[this.#index];
        const next = this.#items[nextIndex];
        if (!current || !next) {
          this.classList.remove('is-reverse');
          return;
        }
        this.#animating = true;

        next.classList.remove('is-active', 'is-leaving', 'is-reset', 'is-current');
        next.classList.add('is-pending');
        next.inert = false;
        next.removeAttribute('aria-hidden');
        next.removeAttribute('hidden');

        const finish = () => {
          if (!this.#animating) return;
          current.classList.add('is-reset');
          current.classList.remove('is-leaving');
          void current.offsetWidth;
          current.classList.remove('is-reset');
          this.classList.remove('is-reverse');
          this.#animating = false;
        };

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            current.classList.remove('is-active', 'is-current');
            current.classList.add('is-leaving');
            current.inert = true;
            current.setAttribute('aria-hidden', 'true');

            next.classList.remove('is-pending');
            next.classList.add('is-active');

            current.addEventListener(
              'transitionend',
              (event) => {
                if (event.target !== current) return;
                if (event.propertyName && event.propertyName !== 'transform') return;
                finish();
              },
              { once: true }
            );
            window.setTimeout(finish, 700);
          });
        });

        this.#index = nextIndex;
      }

      #reveal() {
        if (this.#editorPaused) {
          this.#holdOneSlide();
          return;
        }

        this.classList.remove('is-open', 'is-inspecting');

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const styles = getComputedStyle(this);
        const expandMs = this.#parseDuration(styles.getPropertyValue('--simple-announce-expand-duration'), 1500);
        const fadeMs = this.#parseDuration(styles.getPropertyValue('--simple-announce-fade-duration'), 1500);

        const finish = () => {
          this.classList.add('is-open');
          this.classList.remove('is-expanding', 'is-fading');
          this.#ready = true;
          this.#startCycle();
        };

        if (reduceMotion) {
          finish();
          return;
        }

        const expandEnabled = this.hasAttribute('data-expand');

        const startFade = () => {
          if (this.classList.contains('is-fading') || this.classList.contains('is-open')) return;
          this.classList.add('is-fading');
          window.setTimeout(finish, fadeMs);
        };

        if (!expandEnabled) {
          requestAnimationFrame(() => requestAnimationFrame(startFade));
          return;
        }

        const run = () => {
          this.classList.add('is-expanding');

          const onEnd = (event) => {
            if (event.target !== this) return;
            if (event.propertyName && event.propertyName !== 'grid-template-rows') return;
            this.removeEventListener('transitionend', onEnd);
            startFade();
          };

          this.addEventListener('transitionend', onEnd);
          window.setTimeout(startFade, expandMs + 80);
        };

        window.setTimeout(() => {
          requestAnimationFrame(() => requestAnimationFrame(run));
        }, 160);
      }
    }

    customElements.define('simple-announce-live', SimpleAnnounceLive);
  }

  } catch(e) { console.error(e); }
})();
})();
